import { Validator } from "lakmus";
import { repository } from 'redux-scaffolding-ts';
import { FormStore } from 'src/core/stores/formStore';
import { container } from 'src/inversify.config';
import HttpService from '../core/services/http.service';
import { CommandResult } from '../core/stores/types';

export interface NewWhatsNewReportItem {
    language: string;
    text: string;
    adminText: string;
}

export interface WhatsNewReportItem extends NewWhatsNewReportItem {
    id: string;
}

export class WhatsNewValidator extends Validator<WhatsNewReportItem> {
    constructor() {
        super();

        this.ruleFor(x => x.text)
            .notNull()
            .withMessage("What's new Report must have a text to show");

        this.ruleFor(x => x.language)
            .notNull()
            .withMessage("What's new Report must have a language specified");
    }
}

const WHATSNEW_UPDATE_ITEM = "WHATSNEW_UPDATE_ITEM";

@repository("@@WHATSNEW", "whatsnew.detail")
export class WhatsNewReportStore extends FormStore<WhatsNewReportItem> {
    baseUrl: string = `${process.env.PUBLIC_URL}/api/v1/whatsnew`;

    protected validate(item: WhatsNewReportItem) {
        return new WhatsNewValidator().validate(item);
    }

    constructor() {
        super('WHATSNEW', {
            isBusy: false,
            status: 'New',
            item: undefined,
            result: undefined
        }, container);
        this.addReducer(WHATSNEW_UPDATE_ITEM, (): any => {
            return super.onPatch()
        }, 'AsyncAction');
    }

    public changeUrlByLanguage() {
        this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/whatsnew`;
    }

    public async getById(id: string, params?: any): Promise<WhatsNewReportItem> {
        var httpService = this.container.get<HttpService>(HttpService);
        const result = await this.dispatchAsync(this.ENTITY_LOAD, httpService.get<WhatsNewReportItem>(`${this.baseUrl}/${id}`, params));
        return result.data;
    }

    public async getByLanguage(language: string, params?: any): Promise<WhatsNewReportItem> {
        var httpService = this.container.get(HttpService);
        const result = await this.dispatchAsync(this.ENTITY_LOAD, httpService.get<WhatsNewReportItem>(`${this.baseUrl}/language/${language}`, params));
        return result.data;
    }

    public async update(item: WhatsNewReportItem) {
        var result = await super.put(WHATSNEW_UPDATE_ITEM, `${item.id}`, item) as any;
        return result.data as CommandResult<WhatsNewReportItem>;
    }
}